import { render, staticRenderFns } from "./ShippingItem.vue?vue&type=template&id=4f546edc&"
import script from "./ShippingItem.vue?vue&type=script&lang=js&"
export * from "./ShippingItem.vue?vue&type=script&lang=js&"
import style0 from "./ShippingItem.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports